module.exports = __webpack_public_path__ + "home.ce06a1a4a91ff379f3b9.jpg";


//////////////////
// WEBPACK FOOTER
// C:/Users/PRO/Documents/GitHub/CGStore-Front/src/assets/img/home.jpg
// module id = ../../../../../src/assets/img/home.jpg
// module chunks = styles